import { radius } from './tokens/primitives';

/**
 * Default `theme.shape.borderRadius` is the medium step. Components that
 * need other steps reference primitives via `theme.shape.borderRadius` math
 * or, when there's a clear semantic distinction (chips = `radius.full`,
 * cards = `radius.lg`), import the named token directly in component overrides.
 */
export const shape = {
  borderRadius: radius.md,
};
